import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import { LADDER_ROWS } from './sprintsData';

const LadderLink = ({ item }) =>
  item.noLink ? (
    <>
      <b>{item.code}</b> {item.name}
    </>
  ) : (
    <a href={`#${item.id}`}>
      <b>{item.code}</b> {item.name}
    </a>
  );

const Ladder = () => {
  return (
    <section id="ladder">
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          How the projects <span className={styles.g}>build on each other.</span>
        </h2>
        <p className={styles.secSub}>
          The projects form a ladder. Mini projects teach one skill each; guided projects combine
          several skills into a product; later builds reuse earlier ones — ShipIt takes AskDocs or
          DomainCopilot to AWS, TriageOps runs on your own GateKeeper MCP server, SafeOps hardens
          an earlier build. The capstone is your own product, built from everything above.
        </p>
        <div className={styles.tscroll}>
          <table className={styles.ld}>
            <tbody>
              <tr>
                <th>Theme</th>
                <th>Mini projects</th>
                <th>Guided project</th>
              </tr>
              {LADDER_ROWS.map((row) => (
                <tr key={row.theme}>
                  <td>{row.theme}</td>
                  <td>
                    {row.mini.length === 0
                      ? '—'
                      : row.mini.map((item, i) => (
                          <React.Fragment key={item.code}>
                            {i > 0 && ' · '}
                            <LadderLink item={item} />
                          </React.Fragment>
                        ))}
                  </td>
                  <td>
                    {row.guided.length === 0
                      ? '—'
                      : row.guided.map((item, i) => (
                          <React.Fragment key={item.code}>
                            {i > 0 && ' · '}
                            <LadderLink item={item} />
                          </React.Fragment>
                        ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Ladder;
